export class EntrustedModel {
	description?: string;
	auto_entrust?: boolean;
	entrusted_day?: string;
	entrusted_email?: string;
	entrusted_to?: string;
	id_entrusted_to?: any;
	type?: EntrustedType;
	perito?: boolean;
	dwl_man?: string;
	status?: string;
	number_sx_counterparty?: string;
}

export enum EntrustedType {
	MANAGER = 'MANAGER',
	LEGAL = 'LEGAL',
	INSPECTORATE = 'INSPECTORATE'
}

export const InspectorateList: string[] = [
	'FONDIARIA SAI ISPETTORATO SDM MILANO', 'FONSAI SDM - D.PECORA', 'FONSAI - Perito Zagni', 'FONSAI - Perito Gusmini',
	'FONSAI - Perito De Martino', 'SGS - Ispettorato Dekra', 'WILLIS GENERALI (seguiti)', 'GENERALI ISPETT CARD',
	'ZURICH ISPETT CARD', 'GENERALI ISPETT CARD SR', 'UNIPOL ISPETT CARD'
];

export const LegalList: string[] = [
	'TOMA DONATO', 'TROCANO PIO MARIO', 'DE LUCA PAOLO', 'ALICICCO ALESSANDRO', 'GIUSEPPE TROCANO', 'OFFERTA REALE', 'ACCLAIMS',
	'Multiserass', 'Studio Celletti', 'GBS (GENERALI)', 'WILLCONSULTING', 'WILLCO ZURICH', 'WILLCONSULTING SR', 'ACCLAIMS SR',
	'ALCO SOLUTIONS', 'AON HEWITT'
];

export const ManagerList: string[] = [
	'Armonie Assicurative Srl', 'MARSH (Milano)', 'Multi Serass', 'PCA', 'Crawford', 'Willis Italia Spa', 'AON -MI-', 'Alco Gestione Rischi',
	'Car Assistance', 'Marsh (RM)', 'AON (RM)', 'Zurich (Account manager per Sanofi A.e Kimberly Clark)', 'Dekra', 'Eurorisarcimenti',
	'SG MULTISERASS', 'IT DL ROM Servizio e Dipendenti', 'AON  (Sony)', 'GROUPAMA', 'Marsh Spa', 'Multiserass', 'Willis Italia',
	'AON -MI- (Mondelez)', 'AIG (x ROCHE)', 'AON -MI- (alcatel)', 'Willis Italia Unipol', 'Zurich canale diretto', 'Willis Italia (Diversey)',
	'Willis Italia MI', 'Multiserass (AIG)', 'AON HEWITT', 'TEST GESTORE ENI'
];
